import * as React from 'react';

import styled from 'styled-components';
import { ResponsiveTypography } from 'components/DesignSystemV2/ResponsiveTypography';
import { colorsV2 } from 'style/colors-v2';

import { fromScreen } from 'utils/media-query/responsive.util';
import { IconCourseSocialFacebook } from 'components/Icon/SVGIcons/IconCourseSocialFacebook';
import { IconCourseSocialTiktok } from 'components/Icon/SVGIcons/IconCourseSocialTiktok';
import { IconCourseSocialYoutube } from 'components/Icon/SVGIcons/IconCourseSocialYoutube';

const Container = styled.div`
  padding: 32px 16px;
  margin: 0 auto;
  display: grid;
  gap: 16px;

  ${fromScreen(624)} {
    padding: 80px 32px;
    gap: 24px;
    grid-template-columns: 256px minmax(0, 1fr);
  }
  ${fromScreen(1144)} {
    width: 1080px;
    gap: 112px;
  }
`;

const Contact = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  gap: 16px;
`;
const Info = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  gap: 12px;
`;
const Row = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  gap: 8px;
`;
const RightSide = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${colorsV2.black100};
  display: grid;
  gap: 24px;

  ${fromScreen(928)} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const SocialMedia = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  gap: 24px;
  a {
    color: ${colorsV2.black100};
  }
`;
export const FooterRecruitment = () => {
  return (
    <Container>
      <ResponsiveTypography.Paragraph
        breakpoints={[0, 624]}
        variant={['bold/24-32', 'boldbold/32-40']}
      >
        Join us and be a better you
      </ResponsiveTypography.Paragraph>
      <RightSide>
        <Contact>
          <Row>
            <ResponsiveTypography.Paragraph
              variant="semi-bold/14-20"
              color="black100"
            >
              Liên hệ:
            </ResponsiveTypography.Paragraph>
            <ResponsiveTypography.Paragraph
              variant="regular/14-20"
              color="black100"
            >
              0365701068
            </ResponsiveTypography.Paragraph>
          </Row>
          <Row>
            <ResponsiveTypography.Paragraph
              variant="semi-bold/14-20"
              color="black100"
            >
              Email:
            </ResponsiveTypography.Paragraph>
            <ResponsiveTypography.Paragraph
              variant="regular/14-20"
              color="black100"
            >
              recruitment@dolenglish.vn
            </ResponsiveTypography.Paragraph>
          </Row>
        </Contact>
        <Info>
          <ResponsiveTypography.Paragraph
            variant="regular/14-20"
            color="black100"
          >
            © 2023 DOL English. All rights reserved.
          </ResponsiveTypography.Paragraph>
          <SocialMedia>
            <a
              aria-label={'social'}
              href={'https://www.facebook.com/dolenglish.ieltsdinhluc'}
              rel="nofollow noreferrer"
              target="_blank"
            >
              <IconCourseSocialFacebook fontSize={24} />
            </a>
            <a
              aria-label={'social'}
              href={'https://www.tiktok.com/@dolenglish'}
              rel="nofollow noreferrer"
              target="_blank"
            >
              <IconCourseSocialTiktok fontSize={24} />
            </a>
            <a
              aria-label={'social'}
              href={'https://www.youtube.com/channel/UCEhPLLt928jxgOGDtyzgV9g'}
              rel="nofollow noreferrer"
              target="_blank"
            >
              <IconCourseSocialYoutube fontSize={24} />
            </a>
          </SocialMedia>
        </Info>
      </RightSide>
    </Container>
  );
};
